import api from '@/api';
import { message } from 'antd';

import {
    DEBIT_TYPES,
    TABS,
    DEFAULT_BASE_MONTHS,
    PERIOD,
    DEFAULT_TABLE_DATA,
    SKIP_HOUR_COUNT,
    DEFAULT_FALSE,
    DEFAULT_TRUE,
    DEFAULT_ARRAY,
    DEFAULT_CHARTS_DATA,
    DEFAULT_OBJECT,
    DEFAULT_NULL,
} from '@/components/FactorAnalysis/constants';

import { isEmpty, sortBy } from 'lodash';

const factorAnalysisModel = {
    name: 'factorAnalysis',

    state: {
        tableData: DEFAULT_TABLE_DATA,

        chartsData: DEFAULT_CHARTS_DATA,
        isCulc: DEFAULT_FALSE,
        currentTab: TABS.production,
        debit: {
            production: DEBIT_TYPES.production[0].value,
            injection: DEBIT_TYPES.injection[0].value,
        },

        selectedMiningVersion: {
            production: 0,
            injection: 0,
        },

        currentTp: { tpId: null, node: null, title: null },

        checkedGtmList: DEFAULT_OBJECT,

        uncheckedGtmList: DEFAULT_OBJECT,

        checkedWellList: DEFAULT_OBJECT,

        uncheckedWellList: DEFAULT_OBJECT,

        chartIndicators: DEFAULT_ARRAY,

        virtualGtmList: DEFAULT_ARRAY,

        chartGtm: DEFAULT_NULL, // ГТМ для которого отображается график

        xlsxFileName: DEFAULT_NULL,

        isChartVisible: true,

        isTableVisible: true,

        gtmTreeData: DEFAULT_ARRAY, // Список ГТМ для конкретного типа ФА с учетом скважин

        gtmFaTreeData: DEFAULT_ARRAY, // Список ГТМ для конкретного типа ФА без учета скважин

        gtmList: DEFAULT_OBJECT, // ГТМ для компонента фильтра

        wellList: DEFAULT_OBJECT, // Скважины для компонента фильтра

        wellsForCurrentTp: [], // Скважины для поиска в компоненте добавления мероприятия

        gtmWellList: DEFAULT_ARRAY, // Список пар ГТМ-скважина для указания базового периода

        gtmBasePeriods: DEFAULT_OBJECT, // Настройки базового периода для конкретного ГТМ

        selectedGtmWell: DEFAULT_NULL, // Пара ГТМ-скважина для выбора базового периода

        baseMonthsCount: DEFAULT_BASE_MONTHS,

        isOpenBasePeriodModal: false,

        isOpenSetGtmModal: false,

        // Модальные окна для графиков факторного анализа
        isAxesModalOpen: false,
        isIndicatorsModalOpen: false,

        miningVersionsList: null, // список версий для месторождения

        isSkipMonths: DEFAULT_TRUE,

        isFilterPanelVisible: DEFAULT_FALSE,

        skipHourCount: SKIP_HOUR_COUNT,

        period: PERIOD,

        gtmIds: DEFAULT_ARRAY,

        loading: {
            gtmTreeData: false,
            gtmFaTreeData: false,
            miningVersionsList: false,
            // tableData: DEFAULT_FALSE,
            // chartsData: DEFAULT_FALSE,
            data: DEFAULT_FALSE,
        },
    },

    reducers: {
        setIsSkipMonths(state, payload) {
            return { ...state, isSkipMonths: payload };
        },

        setSkipHourCount(state, payload) {
            return { ...state, skipHourCount: payload };
        },

        setWellsForCurrentTp(state, payload) {
            return { ...state, wellsForCurrentTp: payload };
        },

        setCurrentTp(state, payload) {
            return { ...state, currentTp: payload };
        },

        setIsOpenBasePeriodModal(state) {
            return { ...state, isOpenBasePeriodModal: !state.isOpenBasePeriodModal };
        },

        setIsOpenSetGtmModal(state) {
            return { ...state, isOpenSetGtmModal: !state.isOpenSetGtmModal };
        },

        setIsAxesModalOpen(state, payload) {
            return { ...state, isAxesModalOpen: payload };
        },

        setIsIndicatorsModalOpen(state, payload) {
            return { ...state, isIndicatorsModalOpen: payload };
        },

        setMiningVersionsList(state, payload) {
            return { ...state, miningVersionsList: payload };
        },

        setSelectedMiningVersion(state, payload) {
            return { ...state, selectedMiningVersion: payload };
        },

        setChartGtm(state, payload, faType = null) {
            if (!faType) {
                return { ...state, chartGtm: payload };
            }
            return { ...state, chartGtm: { ...state.chartGtm, [faType]: payload } };
        },

        setIsCulc(state, payload, faType = null) {
            if (!faType) {
                return { ...state, isCulc: payload };
            }
            return { ...state, isCulc: { ...state.isCulc, [faType]: payload } };
        },

        setIsChartVisible(state, payload) {
            return { ...state, isChartVisible: payload };
        },

        setIsTableVisible(state, payload) {
            return { ...state, isTableVisible: payload };
        },

        setWellList(state, payload, faType = null) {
            if (!faType) {
                return { ...state, wellList: payload };
            }
            return { ...state, wellList: { ...state.wellList, [faType]: payload } };
        },

        setGtmBasePeriods(state, payload, faType = null) {
            if (!faType) {
                return { ...state, gtmBasePeriods: payload };
            }
            return { ...state, gtmBasePeriods: { ...state.gtmBasePeriods, [faType]: payload } };
        },

        setXlsxFileName(state, payload, faType = null) {
            if (!faType) {
                return { ...state, xlsxFileName: payload };
            }
            return { ...state, xlsxFileName: { ...state.xlsxFileName, [faType]: payload } };
        },

        setChartIndicators(state, payload, faType = null) {
            if (!faType) {
                return { ...state, chartIndicators: payload };
            }
            return { ...state, chartIndicators: { ...state.chartIndicators, [faType]: payload } };
        },

        setVirtualGtmList(state, payload, faType = null) {
            if (!faType) {
                return { ...state, virtualGtmList: payload };
            }
            return { ...state, virtualGtmList: { ...state.virtualGtmList, [faType]: payload } };
        },

        setGtmList(state, payload, faType = null) {
            if (!faType) {
                return { ...state, gtmList: payload };
            }
            return { ...state, gtmList: { ...state.gtmList, [faType]: payload } };
        },

        setSelectedGtmWell(state, payload, faType = null) {
            if (!faType) {
                return { ...state, selectedGtmWell: payload };
            }
            return { ...state, selectedGtmWell: { ...state.selectedGtmWell, [faType]: payload } };
        },

        setGtmWellList(state, payload, faType = null) {
            if (!faType) {
                return { ...state, gtmWellList: payload };
            }
            return { ...state, gtmWellList: { ...state.gtmWellList, [faType]: payload } };
        },

        setTableData(state, payload, faType = null) {
            if (!faType) {
                return { ...state, tableData: payload };
            }
            return { ...state, tableData: { ...state.tableData, [faType]: payload } };
        },

        setChartsData(state, payload, faType = null) {
            if (!faType) {
                return { ...state, chartsData: payload };
            }
            return { ...state, chartsData: { ...state.chartsData, [faType]: payload } };
        },

        setIsFilterPanelVisible(state, payload, faType = null) {
            if (!faType) {
                return { ...state, isFilterPanelVisible: payload };
            }
            return { ...state, isFilterPanelVisible: { ...state.isFilterPanelVisible, [faType]: payload } };
        },

        setDebit(state, payload) {
            return { ...state, debit: payload };
        },

        setPeriod(state, payload) {
            return { ...state, period: payload };
        },

        setBaseMonthsCount(state, payload) {
            return { ...state, baseMonthsCount: payload };
        },

        setGtmTreeData(state, payload) {
            return { ...state, gtmTreeData: payload };
        },

        setGtmFaTreeData(state, payload) {
            return { ...state, gtmFaTreeData: payload };
        },

        setGtmIds(state, payload) {
            return { ...state, gtmIds: payload };
        },

        setCurrentTab(state, payload) {
            return { ...state, currentTab: payload };
        },

        setCheckedGtmList(state, payload, faType) {
            if (!faType) {
                return { ...state, checkedGtmList: payload };
            }
            return { ...state, checkedGtmList: { ...state.checkedGtmList, [faType]: payload } };
        },

        setUncheckedGtmList(state, payload, faType) {
            if (!faType) {
                return { ...state, uncheckedGtmList: payload };
            }
            return { ...state, uncheckedGtmList: { ...state.uncheckedGtmList, [faType]: payload } };
        },

        setCheckedWellList(state, payload, faType) {
            if (!faType) {
                return { ...state, checkedWellList: payload };
            }
            return { ...state, checkedWellList: { ...state.checkedWellList, [faType]: payload } };
        },

        setUncheckedWellList(state, payload, faType) {
            if (!faType) {
                return { ...state, uncheckedWellList: payload };
            }
            return { ...state, uncheckedWellList: { ...state.uncheckedWellList, [faType]: payload } };
        },

        setGtmTreeDataLoading(state, payload) {
            return {
                ...state,
                loading: {
                    ...state.loading,
                    gtmTreeData: payload,
                },
            };
        },

        setGtmFaTreeDataLoading(state, payload) {
            return {
                ...state,
                loading: {
                    ...state.loading,
                    gtmFaTreeData: payload,
                },
            };
        },

        setMiningVersionsListLoading(state, payload) {
            return {
                ...state,
                loading: {
                    ...state.loading,
                    miningVersionsList: payload,
                },
            };
        },

        setDataLoading(state, payload, faType) {
            return {
                ...state,
                loading: {
                    ...state.loading,
                    data: { ...state.loading.data, [faType]: payload },
                },
            };
        },
    },

    effects: dispatch => ({
        async fetchMiningVersionsAsync(params) {
            this.setMiningVersionsListLoading(true);

            try {
                const response = await api.factorAnalysis.fetchMiningVersions(params);
                this.setMiningVersionsList(response);
            } catch (error) {
                message.error('Не удалось получить данные по версиям добычи');
                this.setMiningVersionsList(null);
            } finally {
                this.setMiningVersionsListLoading(false);
            }
        },

        async fetchGtmTree(params) {
            this.setGtmTreeDataLoading(true);
            try {
                const gtmTreeData = await api.factorAnalysis.fetchGtmTree(params);
                const gtmIds = {};

                for (const faType in gtmTreeData) {
                    gtmIds[faType] = [];
                    gtmTreeData[faType].map(group => {
                        group.children.map(child => {
                            gtmIds[faType].push(child.key);
                        });
                    });
                }
                this.setGtmIds(gtmIds);
                this.setGtmTreeData(gtmTreeData);
            } catch (error) {
                message.error('Не удалось получить данные по мероприятиям');
                this.setGtmTreeData(null);
            } finally {
                this.setGtmTreeDataLoading(false);
            }
        },

        async fetchGtmFaTree() {
            this.setGtmFaTreeDataLoading(true);
            try {
                const gtmFaTreeData = await api.factorAnalysis.fetchGtmFaTree();

                this.setGtmFaTreeData(gtmFaTreeData);
            } catch (error) {
                message.error('Не удалось получить данные по мероприятиям');
                this.setGtmFaTreeData(null);
            } finally {
                this.setGtmFaTreeDataLoading(false);
            }
        },

        async fetchWellsForCurrentTp(params) {
            try {
                const wellsForCurrentTp = await api.factorAnalysis.fetchWellsForCurrentTp(params);
                this.setWellsForCurrentTp(wellsForCurrentTp);
            } catch (error) {
                message.error('Не удалось получить данные по скважинам');
                this.setWellsForCurrentTp({});
            }
        },

        async calculate(params, state) {
            const { requestParameters } = params;

            const faType = requestParameters.faType;
            const wellList = {};
            const gtmList = {};
            const gtmWellList = {};
            const gtmBasePeriods = {};

            const checkedGtmList = {};
            const uncheckedGtmList = {};
            const checkedWellList = {};
            const uncheckedWellList = {};

            const chartIndicators = [];

            this.setIsCulc(true, faType);

            try {
                this.setDataLoading(true, faType);
                const data = await api.factorAnalysis.fetchFactorAnalysisData(requestParameters);
                this.setTableData(data.table_data, faType);

                data.table_data.rows.forEach(row => {
                    wellList[row.WellId] = {
                        label: row.wellNumber,
                        value: row.WellId,
                        isChecked: true,
                        isVisible: true,
                    };
                    checkedWellList[row.WellId] = {
                        label: row.wellNumber,
                        value: row.WellId,
                        isChecked: true,
                        isVisible: true,
                    };
                    uncheckedWellList[row.WellId] = {
                        label: row.wellNumber,
                        value: row.WellId,
                        isChecked: false,
                        isVisible: true,
                    };

                    gtmList[row.technology] = {
                        label: row.technology,
                        value: row.technology,
                        isChecked: true,
                        isVisible: true,
                    };
                    checkedGtmList[row.technology] = {
                        label: row.technology,
                        value: row.technology,
                        isChecked: true,
                        isVisible: true,
                    };
                    uncheckedGtmList[row.technology] = {
                        label: row.technology,
                        value: row.technology,
                        isChecked: false,
                        isVisible: true,
                    };

                    gtmWellList[row.idx] = {
                        label: `${row.technology} - ${row.wellNumber}`,
                        value: row.idx,
                        wellNumber: row.wellNumber,
                        gtm: row.technology,
                    };
                    gtmBasePeriods[row.idx] = { baseMonthsCount: null, endOfPeriod: null };
                });

                this.setWellList(wellList, faType);
                this.setGtmList(gtmList, faType);

                this.setCheckedGtmList(checkedGtmList, faType);
                this.setUncheckedGtmList(uncheckedGtmList, faType);
                this.setCheckedWellList(checkedWellList, faType);
                this.setUncheckedWellList(uncheckedWellList, faType);

                this.setGtmWellList(Object.values(sortBy(gtmWellList, o => +o.wellNumber)), faType);
                this.setChartsData(data.charts_data, faType);
                this.setXlsxFileName(data.xlsx_file_name, faType);

                if (isEmpty(state.factorAnalysis.gtmBasePeriods[faType]))
                    this.setGtmBasePeriods(gtmBasePeriods, faType);

                if (isEmpty(state.factorAnalysis.chartIndicators[faType]))
                    this.setChartIndicators(chartIndicators, faType);

                if (data.table_data.rows.length) {
                    const firstRow = data.table_data.rows[0];

                    this.setChartGtm(
                        {
                            idx: firstRow.idx,
                            wellNumber: firstRow.wellNumber,
                            gtm: firstRow.technology,
                        },
                        faType
                    );

                    this.setSelectedGtmWell(firstRow.idx, faType);
                }
            } catch (error) {
                message.error('Не удалось выполнить расчёт');
            } finally {
                this.setDataLoading(false, faType);
            }
        },

        dropStoreToDefault() {
            this.setGtmWellList(DEFAULT_ARRAY);
            this.setWellList(DEFAULT_OBJECT);
            this.setGtmList(DEFAULT_OBJECT);
            this.setVirtualGtmList(DEFAULT_ARRAY);
            this.setChartsData(DEFAULT_CHARTS_DATA);
            this.setGtmIds(DEFAULT_ARRAY);
            this.setIsCulc(DEFAULT_FALSE);
            this.setGtmTreeData(DEFAULT_ARRAY);
            this.setGtmFaTreeData(DEFAULT_ARRAY);
            this.setTableData(DEFAULT_TABLE_DATA);
            this.setGtmBasePeriods(DEFAULT_OBJECT);
            this.setCheckedGtmList(DEFAULT_OBJECT);
            this.setUncheckedGtmList(DEFAULT_OBJECT);
            this.setCheckedWellList(DEFAULT_OBJECT);
            this.setUncheckedWellList(DEFAULT_OBJECT);
            this.setChartGtm(DEFAULT_NULL);
            this.setBaseMonthsCount(DEFAULT_BASE_MONTHS);
            this.setChartIndicators(DEFAULT_ARRAY);
            this.setSelectedGtmWell(DEFAULT_NULL);
            this.setIsFilterPanelVisible(DEFAULT_FALSE);
            this.setSkipHourCount(SKIP_HOUR_COUNT);
            this.setPeriod(PERIOD);
            this.setXlsxFileName(DEFAULT_NULL);
            this.setWellsForCurrentTp([]);
        },
    }),
};

export default factorAnalysisModel;
